import { SET_BEACHHEAD_DATA } from './actions';

const initialState = {
  data: null
};

const beachheadReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BEACHHEAD_DATA:
      return {
        ...state,
        data: action.payload
      };
    default:
      return state;
  }
};

export default beachheadReducer;
